import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Button, Navbar, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import logoImage from "../../assets/images/DailyTaskLogo.png";

const navLinkStyle = (isActive) => ({
  borderRadius: "8px",
  padding: "6px 14px",
  fontWeight: isActive ? "600" : "400",
  color: isActive ? "#fff" : "#333",
  backgroundColor: isActive ? "#0d6efd" : "transparent",
  transition: "background-color 0.2s, color 0.2s",
});

const NavbarSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Navbar expand="lg" bg="white" className="shadow-sm py-3">
      <Container>
        <Navbar.Brand href="#" className="d-flex align-items-center">
          <img src={logoImage} alt="Logo" height="60" className="me-2" />
          <span className="fw-bold text-dark fs-4">Daily Post Hub</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav className="align-items-center gap-3">
            <Nav.Link
              onClick={() => navigate("/")}
              style={navLinkStyle(location.pathname === "/")}
              className="nav-hover"
            >Home</Nav.Link>
            <Nav.Link
              onClick={() => navigate("/aboutus")}
              style={navLinkStyle(location.pathname === "/aboutus")}
              className="nav-hover"
            >About Us</Nav.Link>
            <Nav.Link
              onClick={() => navigate("/contactus")}
              style={navLinkStyle(location.pathname === "/contactus")}
              className="nav-hover"
            >Contact Us</Nav.Link>
            {/* <Button
              variant="success"
              size="sm"
              className="fw-bold"
              onClick={() => navigate("/login")}
            >
              Sign In
            </Button> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarSection;
